


























































































































import { Component, Vue } from 'vue-property-decorator';
import { PerfectScrollbar } from 'vue2-perfect-scrollbar';
const { Carousel3d, Slide } = require('vue-carousel-3d'); // warningが出るため
// import { Carousel3d, Slide } from 'vue-carousel-3d';
import AccountIcon from '@/components/common/AccountIcon.vue';

/**
 * ユーザ型
 */
interface User {
  // ユーザID
  id: string;
  // ユーザ名
  name: string;
  // アバターアイコン画像URL
  userIcon: string;
  // アサインされているプロジェク名トリスト
  projects: Array<string>;
}

/**
 * 稼働情報型
 */
interface OperationInfo {
  // ユーザID
  userId: string;
  // ユーザ
  user: User;
  // 開始時間
  start: string;
  // 終了時間
  end: string;
  // 稼働時間数
  totalHours: number;
}

/**
 * 日別の稼働情報リスト型
 */
interface DayOperationInfoList {
  // 今日かどうか
  isToday: boolean;
  // 日付
  date: string;
  // リスト
  list: Array<OperationInfo>;
}

@Component({
  components: {
    PerfectScrollbar,
    Carousel3d,
    Slide,
    AccountIcon
  },
})
export default class OperationMemberList extends Vue {
  // ダミーデータ
  private dammyUserIcon: string = require('../../assets/test.jpeg');
  private dummyUsers = require('../../repository/mock/dummyData/operationMemberList/users.json').users;
  private dummyOperationInfoList = require('../../repository/mock/dummyData/operationMemberList/operationInfoList.json')
    .operationInfoList;


  private inverseScaling: number = 0;

  private display: number = 5;

  private border: number = 0;

  // 開始番号
  private startIndex: number = 1;

  // タイトル
  private title: string = '';

  // ユーザリスト
  private users: Array<User> = [];

  // 稼働情報リスト
  private dayOperationInfoList: Array<DayOperationInfoList> = [];

  // スライド幅
  private slideWidth: number = 400;

  // スライド高さ
  private slideHeight: number = 582;

  // スライド間隔
  private slideSpace: number = 420;

  // サイドスライドの被せものの幅
  private sideCoverWidth: number = 50;

  // 3D表現表示するかどうか
  private disable3d: boolean = false;

  // ★をクリックした時の処理
  private  multiplesliderHandler() {
    this.left_slider(),
    this.right_slider()
  }

　　// 右側のウィンドウのクラスの変更
  private right_slider() {
    // right-1を取得
    const test = Array.from(document.getElementsByClassName('right-1'));
    test.forEach((element: any) => {
      // ★をクリックした状態かの判別
      if (this.disable3d === false) {
    　 // クリックしてない状態なら傾きをつけるクラスを付与
        element.classList.add('right_slider');
      } else {
        element.classList.remove('right_slider');
      }
    });
  }
　　// 左側のウィンドウのクラスの変更
  private left_slider() {
     // left-1を取得
    const test1 = Array.from(document.getElementsByClassName('left-1'));
    test1.forEach((element: any) => {
      // ★をクリックした状態かの判別
      if (this.disable3d === false) {
      // クリックしてない状態なら傾きをつけるクラスを付与
        element.classList.add('left_slider');
      } else {
        element.classList.remove('left_slider');
      }
    });
  }

  private async mounted() {
    // ダミーデータからデータを作成
    this.createDataFromDummyData();

    // 画面リサイズをハンドリング
    window.addEventListener('resize', this.handleResize);
    await new Promise((resolve) => setTimeout(resolve, 1)); // 1ミリ秒待つ
    this.handleResize();
    // ちゃんと描写されないため処理を遅らせて発火させる
    window.addEventListener('slider', this.multiplesliderHandler);
    await new Promise((slider) => setTimeout(slider, 1));
    this.multiplesliderHandler();
  }

  private beforeDestroy() {
    // 画面リサイズのハンドリング解除
    window.removeEventListener('resize', this.handleResize);
  }

  /**
   * 画面リサイズハンドラ
   */
  private handleResize(e?: Event) {
    // カルーセルのサイズを調整
    const carouselDom: any = this.$refs.carousel;
    if (carouselDom) {
      const areaWidth: number = carouselDom.$el.offsetWidth;
      this.slideWidth = areaWidth * 0.7;
      this.slideSpace = this.slideWidth - 10;
      this.sideCoverWidth = areaWidth * 0.15;
    }
  }

  /**
   * スライドの切り替わりハンドラ
   */
  private async　onBeforeSlideChange(index: any) {
    this.startIndex = index;
    // ちゃんと描写されないため処理を遅らせて発火させる
    window.addEventListener('slider', this.multiplesliderHandler);
    await new Promise((slider) => setTimeout(slider, 1));
    this.multiplesliderHandler();
  }

  /**
   * 次へ
   */
  private next() {
    const carousel: any = this.$refs.carousel;
    carousel.goNext();
  }

  /**
   * 前へ
   */
  private prev() {
    const carousel: any = this.$refs.carousel;
    carousel.goPrev();
  }

  /**
   * 次へ
   */
  private home() {
    const carousel: any = this.$refs.carousel;
    carousel.goSlide(1);
  }

  /**
   * テスト用：ダミーデータからデータを作成
   */
  private createDataFromDummyData() {
    // テストデータからデータを準備
    this.dummyUsers.forEach((element: any) => {
      const item: User = element as User;
      item.userIcon = this.dammyUserIcon;
      this.users.push(item);
    });
    this.dummyOperationInfoList.forEach((element: any) => {
      const item = element as DayOperationInfoList;

      // ユーザ情報を組み合わせる
      item.list.forEach((operationInfo: OperationInfo) => {
        operationInfo.user = this.users.find((v) => v.id === operationInfo.userId)!;
      });

      this.dayOperationInfoList.push(item);
    });
  }
}
